// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"87":"3008e56b","897":"833221a6"}[chunkId] + ".chunk.css";
};